import { Component, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WarehouseService } from '../../_services/warehouse.service';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-new-warehouse-modal',
  templateUrl: './warehouse-modal.component.html',
  styleUrls: ['./warehouse-modal.component.css']
})
export class WarehouseModalComponent implements OnInit {

  @Output() refresh: EventEmitter<object> = new EventEmitter<object>();
  private creating_warehouse: boolean = false;
  private field: string;

  constructor(private elRef:ElementRef, private service: WarehouseService) { }

  new_warehouse = new FormGroup({
    name: new FormControl('', [Validators.required]),
    note: new FormControl('')
  })

  ngOnInit() {
  }

  
  openModal(field, name?){
    this.field = field;
    if(name) this.new_warehouse.patchValue({name: name});
    jQuery('#add-warehouse-modal .dropdown').dropdown('restore defaults'); // Clear the Select
    jQuery('#add-warehouse-modal').modal({inverted: true}).modal('show');
  }

  
  submitWarehouseForm(){
    this.new_warehouse.disable();
    this.creating_warehouse = true; // Disable the loading button apparition
    jQuery('#add-warehouse-modal').modal({closable: false})
    this.createWarehouse();
  }

  createWarehouse(){
    this.service.createWarehouse(this.new_warehouse.value)
      .subscribe(response => {
        jQuery('#add-warehouse-modal').modal({closable: true}).modal('hide'); // Set the modal closable & Close the modal
        this.creating_warehouse = false;
        this.new_warehouse.enable(); // Re Enable the Form
        this.new_warehouse.reset(); // Reset It
        this.refresh.emit({field: this.field, value: response.id}); // Emmit the refresh Event
    })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse-modal/warehouse-modal.component.ts